import useSWR from "swr";
import axios, { AxiosError } from "axios";

import { Option } from "models/Option";

export type HistoricalShipmentCitiesUrl =
  | "/api/carriers/historicalShipmentOriginCities"
  | "/api/carriers/historicalShipmentDestinationCities";

type HistoricalShipmentCitySearch = [
  url: HistoricalShipmentCitiesUrl,
  search: string,
  countryCodes: string[]
];

const noCities: string[] = [];

const fetchHistoricalShipmentCities = ([
  url,
  search,
  countryCodes,
]: HistoricalShipmentCitySearch) => {
  const params = new URLSearchParams({ search });

  countryCodes.forEach((countryCode) =>
    params.append("countryCodes", countryCode)
  );

  return axios
    .get<string[]>(`${url}?${params}`)
    .then((response) => response.data);
};

export const useSearchHistoricalShipmentCities = (
  url: HistoricalShipmentCitiesUrl,
  search: string,
  countryCodes: string[],
  searchMinLength: number | null
) => {
  const citySearch: HistoricalShipmentCitySearch | null =
    searchMinLength !== null && search.length >= searchMinLength
      ? [url, search, countryCodes]
      : null;

  const { data, error, isLoading } = useSWR<
    string[],
    AxiosError,
    HistoricalShipmentCitySearch | null
  >(citySearch, fetchHistoricalShipmentCities, {
    keepPreviousData: true,
    revalidateOnFocus: false,
  });

  return {
    data: data ?? noCities,
    error,
    isLoading,
  };
};

export const getShipmentCityOptions = (
  cities: string[],
  selectedCities: string[]
): Option<string>[] =>
  Array.from(new Set([...cities, ...selectedCities])).map((city) => ({
    key: city,
    value: city,
    text: city,
  }));
